import React, {FC, ReactElement} from "react";
import {Box, Container, Grid, Link} from "@mui/material";
import Copyright from "./Copyright";
import useAuth from "../../../hooks/useAuth";
import Typography from "@mui/material/Typography";
import {Trans} from "@lingui/react/macro";

export const Footer: FC = (): ReactElement => {

    const {isAuthenticated} = useAuth();

    return (
        <Box
            sx={ {
                width: "100%",
                height: "7rem",
                paddingTop: "3rem",
                paddingBottom: "2rem",
            } }
        >
            <Container maxWidth="lg">
                {!isAuthenticated &&
                    <Grid container direction="column" sx={{ alignItems: "center" }}>
                        <Grid item xs={12}>
                            <Typography variant="body2" align="center" sx={{ color: "text.secondary" }}>
                                <Link color="inherit" href="/app-release.apk">
                                    <Trans>Download Mobile App</Trans>
                                </Link>
                            </Typography>
                            <Typography variant="body2" align="center" sx={{ color: "text.secondary" }}>
                                <Link color="inherit" href="https://www.lifewire.com/install-apk-on-android-4177185">
                                    <Trans>How to Install APK on Android</Trans>
                                </Link>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            &nbsp;
                        </Grid>
                    </Grid>
                }
                <Copyright/>
            </Container>
        </Box>
    );
};

export default Footer;